import React, { useEffect, useRef, useState } from 'react';
import '../assets/styles/Lantern.scss';

type LanternProps = {
  mode?: string;
};

export default function Lantern({ mode = 'dark' }: LanternProps) {
  const rafRef = useRef<number | null>(null);
  const [isDesktop] = useState<boolean>(() => {
    try {
      // Prefer capability-based detection: pointer/hover indicates an input fine enough for a lantern
      return window.matchMedia('(hover: hover) and (pointer: fine)').matches || window.innerWidth > 900;
    } catch (e) {
      return true;
    }
  });

  useEffect(() => {
    // if not desktop-like device, don't attach listeners or render the overlay
    if (!isDesktop) return;
    const root = document.documentElement;

    let mouseX = window.innerWidth / 2;
    let mouseY = window.innerHeight / 2;

    function updateVars() {
      root.style.setProperty('--lantern-x', `${mouseX}px`);
      root.style.setProperty('--lantern-y', `${mouseY}px`);
      rafRef.current = null;
    }

    function onMove(e: MouseEvent) {
      mouseX = e.clientX;
      mouseY = e.clientY;
      if (rafRef.current === null) rafRef.current = requestAnimationFrame(updateVars);
    }

    // initialize
    updateVars();

    window.addEventListener('mousemove', onMove);

    return () => {
      window.removeEventListener('mousemove', onMove);
      if (rafRef.current) cancelAnimationFrame(rafRef.current);
    };
  }, [isDesktop]);

  // Only render the overlay when in dark mode and on desktop-like devices
  if (mode !== 'dark' || !isDesktop) return null;

  return <div className="lantern-overlay" aria-hidden="true" />;
}
